import { render, staticRenderFns } from "./BillTotalsForm.vue?vue&type=template&id=11289c5d&"
import script from "./BillTotalsForm.vue?vue&type=script&lang=js&"
export * from "./BillTotalsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports